import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { LocalCacheService } from '../../services/localCache.service';
import { MomentPipe } from '../../utils/moment.pipe';
import moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PDSService } from '../../services/pds.service';
import { EmailQuoteComponent } from '../email-quote/email-quote.component';
import {
  TravelerFormValidator,
  TravelerValidatorService,
} from '../../services/traveler-validator.service';
import { Router } from '@angular/router';
import { DateService } from '../../services/date.service';

@Component({
  selector: 'app-footer-price-breakdown',
  standalone: true,
  imports: [CommonModule, MomentPipe, EmailQuoteComponent],
  templateUrl: './footer-price-breakdown.component.html',
  styleUrl: './footer-price-breakdown.component.scss',
})
export class FooterPriceBreakdownComponent implements OnInit, OnDestroy {
  @Input() selectedCover: any;
  @Input() quoteEnquiry: any;
  @Input() quoteDetail: any;
  @Input() step: any;
  @Input() submitBtnLabel: string = 'Proceed';
  @Input() enableSubmitBtn: boolean = true;
  @Input() expButtonColor: string = '';
  @Output() onSubmitBtnClick: EventEmitter<any> = new EventEmitter();
  travellersAge: string = '';
  selectedCoverDetail$!: Observable<any>;
  autoClubName = environment.autoClub;
  private subscriptions: Subscription = new Subscription();
  isPastDate: boolean = false;

  constructor(
    private localCacheService: LocalCacheService,
    private pdsService: PDSService,
    private travelerValidatorService: TravelerValidatorService,
    private router: Router,
    private dateService: DateService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  @ViewChild('saveAndSendEmail')
  saveAndSendEmail!: EmailQuoteComponent;

  openSaveAndSendModal() {
    this.checkDepartDateValidation(this.quoteEnquiry.depart);
    const pathSegment = this.router.url;
    const isSameDetails =
      this.localCacheService.getSessionStorage('isSameDetails') || false;
    if (pathSegment === '/quotes-steps-two') {
      this.travelerValidatorService.triggerFormValidation();
    } else {
      if (this.isPastDate) {
        if (isPlatformBrowser(this.platformId)) {
          const modalElement = document.getElementById('pastDateFooter');
          import('bootstrap').then(({ Modal }) => {
            if (modalElement) {
              const modal = new Modal(modalElement);
              modal.show();
            }
          });
        }
      } else {
        if (isSameDetails) {
          this.saveAndSendEmail?.openModal(true);
        } else {
          this.saveAndSendEmail?.openModal();
        }
      }
    }
  }

  checkDepartDateValidation(depart: any) {
    const selectedDate = new Date(depart);
    selectedDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (selectedDate < today) {
      this.isPastDate = true;
    } else {
      this.isPastDate = false;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  ngOnInit() {
    this.subscriptions.add(
      this.travelerValidatorService.validateFormSubject$.subscribe(
        (validatorFlag: TravelerFormValidator) => {
          if (!validatorFlag.IsValid) {
            this.saveAndSendEmail?.openModal(true);
          } else {
            this.saveAndSendEmail?.openModal(false);
          }
        },
      ),
    );
  }

  get countryNames(): string {
    return this.quoteEnquiry?.travelDestination
      .map((country: any) => country.countryName)
      .join(', ');
  }

  get travelDays() {
    const days = this.dateService.diffInDaysInclusive(this.quoteEnquiry?.return, this.quoteEnquiry?.depart);
    return days;
  }

  get displayTravellersAge(): string {
    this.travellersAge = this.quoteEnquiry?.age1;
    if (this.quoteEnquiry?.age2) {
      this.travellersAge = this.travellersAge + ',' + this.quoteEnquiry.age2;
    }
    return this.travellersAge;
  }

  get getDependentsNum() {
    return Number(this.quoteEnquiry?.dependentsCount);
  }

  downloadPDS() {
    this.pdsService.downloadLatestPDSPDF();
  }

  onSubmitClick() {
    this.enableSubmitBtn = false;
    this.onSubmitBtnClick.emit();
    setTimeout(() => {
      this.enableSubmitBtn = true;
    }, 1500);
  }
}
